import React from 'react'
import './Blogsec.css'
import bimg from '../../assets/blog/img-1.png'
import img1 from '../../assets/blog/Why-Automotive-Indus.jpg'
import img2 from '../../assets/blog/How-to-Crack-VLSI-Job-Interviews-Common-Questions-Tips.jpg'
import img3 from '../../assets/blog/image-464.png'
import img4 from '../../assets/blog/Discovering-the-Benefits-of-Job-Oriented-VLSI-Courses.webp'
import { Link } from 'react-router-dom'

const Blogsec = () => {
  return (
    <div class="blog-section ws-section pb-lg-5">
        <div class="container text-center">
            <div class="row justify-content-center pb-5">
                <div class="col-lg-6">
                    <h2 class="ws-section_heading">Blogs</h2>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-7">
                    <a href='#'>
                    <div className='latestPostCard mb-3'>
                        <div class="latestPostCard-img">
                            <img src={bimg} alt=''/>
                        </div>
                        <div class="latestPostCard-content">
                        <h6 class="latestPostCard-title text-white mb-4">Exploring the Best VLSI Design Courses in Hyderabad</h6>
                        <div className='d-flex justify-content-between'>
                        <div className='latestPostCard-left d-flex justify-content-between'>
                        <div class="latestPostCard-author-name text-white me-3 text-xs text-md-lg">By admin</div>
                        <div class="ms-latestPostCard__author-date-text ms-para text-white">May 18, 2023</div>
                        </div>
                        <div class="latestPostCard-category text-white">VLSI Industry</div>
                        </div>
                       
                    </div>
                    </div>
                    </a>
                </div>
                <div class="col-lg-5">
                    <div className='postCard d-flex flex-column flex-sm-row mb-3'>
                        
                        <a href='#'>
                        <div class="postCard-thumbnail overflow-hidden">
                                <img src={img1} alt=''/>
                        </div>
                        <div class="postCard-content align-self-center">
                            <div className='d-flex'>
                        <div class="postCard-category mb-3">VLSI Industry</div>
                        </div>
                            <h6 class="postCard-title ">Why Automotive Industry Needs More VLSI Engineers?</h6>
                       
                        <div className='postCard-left d-flex justify-content-between'>
                        <div class="postCard-author-name me-3 text-xs text-md-lg">By admin</div>
                        <div class="postCard__author-date-text ms-para">Feb 24, 2025</div>
                        </div>
                       
                        </div>
                        </a>
                    </div>
                    <div className='postCard d-flex flex-column flex-sm-row mb-3'>
                        <a href='#'>
                            <div class="postCard-thumbnail overflow-hidden">
                                <img src={img2} alt=''/>
                            </div>
                        <div class="postCard-content align-self-center">
                            <div className='d-flex'>
                        <div class="postCard-category mb-3">VLSI Industry</div>
                        </div>
                            <h6 class="postCard-title ">How to Crack VLSI Job Interviews: Common Questions & Tips</h6>
                       
                        <div className='postCard-left d-flex justify-content-between'>
                        <div class="postCard-author-name me-3 text-xs text-md-lg">By admin</div>
                        <div class="postCard__author-date-text ms-para">Feb 24, 2025</div>
                        </div>
                       
                        </div>
                        </a>
                    </div>
                    <div className='postCard d-flex flex-column flex-sm-row mb-3'>
                        <a href='#'>
                            <div class="postCard-thumbnail overflow-hidden">
                                <img src={img3} alt=''/>
                            </div>
                        <div class="postCard-content align-self-center">
                            <div className='d-flex'>
                        <div class="postCard-category mb-3">VLSI Industry</div>
                        </div>
                            <h6 class="postCard-title ">EDA Tools Integration for Physical Design Automation (PDA)
</h6>
                       
                        <div className='postCard-left d-flex justify-content-between'>
                        <div class="postCard-author-name me-3 text-xs text-md-lg">By admin</div>
                        <div class="postCard__author-date-text ms-para">Mar 12, 2025</div>
                        </div>
                       
                        </div>
                        </a>
                    </div>
                    <div className='postCard d-flex flex-column flex-sm-row mb-3'>
                        <a href='#'>
                            <div class="postCard-thumbnail overflow-hidden">
                                <img src={img4} alt=''/>
                            </div>
                        <div class="postCard-content align-self-center">
                            <div className='d-flex'>
                        <div class="postCard-category mb-3">VLSI Industry</div>
                        </div>
                            <h6 class="postCard-title ">Discovering the Benefits of Job-Oriented VLSI Courses</h6>
                       
                        <div className='postCard-left d-flex justify-content-between'>
                        <div class="postCard-author-name me-3 text-xs text-md-lg">By admin</div>
                        <div class="postCard__author-date-text ms-para">Feb 7, 2025</div>
                        </div>
                       
                        </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Blogsec